import { createMuiTheme } from '@material-ui/core';

export const version = process.env.REACT_APP_VERSION;
export const buildNumber = process.env.REACT_APP_BUILD_NUMBER;
export const apiUrl = process.env.REACT_APP_API_URL;
export const tokenUrl = process.env.REACT_APP_TOKEN_URL;
export const envName = process.env.REACT_APP_ENV_NAME;

export const MaxFileUploadSize = 5242880; // 5 MB
export const MaxOfferFileUploadSize = 31457280; // 30 MB

export const snackbar = createMuiTheme({
    overrides: {
        MuiSnackbarContent: {
            root: {
                width: '90%',
                alignItems: 'start'
            },
            action: {
                paddingTop: 5,
                paddingLeft: 0,
                display: 'flow-root'
            },
            message: {
                width: '90%'
            }
        },
        MuiSnackbar: {
            root: {
                alignItems: "start"
            }
        },
        MuiIconButton: {
            root: {
                padding: 0
            }
        }

    }
});

